import type { OfferingCategory } from "@albertine/types";

export const typeMappings: {
    type: string;
    offeringCategory: OfferingCategory;
}[] = [
    // In order of importance
    {
        type: "lodging",
        offeringCategory: "accommodation",
    },
    { type: "restaurant", offeringCategory: "dining" },
    { type: "bar", offeringCategory: "nightlife" },
    { type: "accounting", offeringCategory: "services" },
    { type: "cafe", offeringCategory: "dining" },
    {
        type: "night_club",
        offeringCategory: "nightlife",
    },
    {
        type: "department_store",
        offeringCategory: "shopping",
    },
    {
        type: "clothing_store",
        offeringCategory: "shopping",
    },
    { type: "jewelry_store", offeringCategory: "shopping" },
    { type: "shopping_mall", offeringCategory: "shopping" },
    { type: "store", offeringCategory: "shopping" },
    {
        type: "airport",
        offeringCategory: "transportation",
    },
    {
        type: "train_station",
        offeringCategory: "transportation",
    },
    {
        type: "museum",
        offeringCategory: "localExperience",
    },
    {
        type: "art_gallery",
        offeringCategory: "localExperience",
    },
    {
        type: "tourist_attraction",
        offeringCategory: "localExperience",
    },
    {
        type: "stadium",
        offeringCategory: "localExperience",
    },
    {
        type: "amusement_park",
        offeringCategory: "localExperience",
    },
    {
        type: "aquarium",
        offeringCategory: "localExperience",
    },
    { type: "bakery", offeringCategory: "shopping" },
    { type: "bank", offeringCategory: "services" },
    { type: "beauty_salon", offeringCategory: "wellness" },
    { type: "bicycle_store", offeringCategory: "shopping" },
    { type: "book_store", offeringCategory: "shopping" },
    {
        type: "bowling_alley",
        offeringCategory: "localExperience",
    },
    {
        type: "bus_station",
        offeringCategory: "transportation",
    },
    {
        type: "campground",
        offeringCategory: "accommodation",
    },
    { type: "car_dealer", offeringCategory: "services" },
    {
        type: "car_rental",
        offeringCategory: "transportation",
    },
    {
        type: "chauffeur_service",
        offeringCategory: "transportation",
    },
    {
        type: "transportation_service",
        offeringCategory: "transportation",
    },
    {
        type: "taxi_service",
        offeringCategory: "transportation",
    },
    {
        type: "taxi_stand",
        offeringCategory: "transportation",
    },
    { type: "car_repair", offeringCategory: "services" },
    { type: "car_wash", offeringCategory: "services" },
    { type: "casino", offeringCategory: "nightlife" },
    {
        type: "cemetery",
        offeringCategory: "localExperience",
    },
    { type: "church", offeringCategory: "localExperience" },
    {
        type: "city_hall",

        offeringCategory: "localExperience",
    },

    {
        type: "convenience_store",

        offeringCategory: "shopping",
    },
    {
        type: "courthouse",

        offeringCategory: "localExperience",
    },
    { type: "dentist", offeringCategory: "services" },
    { type: "doctor", offeringCategory: "services" },
    { type: "drugstore", offeringCategory: "shopping" },
    { type: "electrician", offeringCategory: "services" },
    {
        type: "electronics_store",

        offeringCategory: "shopping",
    },
    { type: "embassy", offeringCategory: "services" },
    { type: "florist", offeringCategory: "shopping" },
    {
        type: "furniture_store",

        offeringCategory: "shopping",
    },
    { type: "gym", offeringCategory: "wellness" },
    { type: "hair_care", offeringCategory: "wellness" },
    {
        type: "hardware_store",

        offeringCategory: "shopping",
    },
    {
        type: "hindu_temple",

        offeringCategory: "localExperience",
    },
    {
        type: "home_goods_store",

        offeringCategory: "shopping",
    },
    { type: "laundry", offeringCategory: "services" },
    {
        type: "library",

        offeringCategory: "localExperience",
    },
    {
        type: "light_rail_station",

        offeringCategory: "transportation",
    },
    { type: "liquor_store", offeringCategory: "shopping" },
    { type: "mosque", offeringCategory: "localExperience" },
    {
        type: "movie_theater",

        offeringCategory: "nightlife",
    },
    { type: "moving_company", offeringCategory: "services" },
    {
        type: "park",

        offeringCategory: "localExperience",
    },
    {
        type: "physiotherapist",

        offeringCategory: "wellness",
    },
    { type: "shoe_store", offeringCategory: "shopping" },
    { type: "spa", offeringCategory: "wellness" },
    {
        type: "synagogue",

        offeringCategory: "localExperience",
    },
    {
        type: "university",

        offeringCategory: "localExperience",
    },
    {
        type: "zoo",

        offeringCategory: "localExperience",
    },
    {
        type: "archipelago",

        offeringCategory: "localExperience",
    },
    { type: "health", offeringCategory: "wellness" },
    {
        type: "landmark",

        offeringCategory: "localExperience",
    },
    {
        type: "natural_feature",

        offeringCategory: "localExperience",
    },
    {
        type: "neighborhood",

        offeringCategory: "localExperience",
    },
    {
        type: "place_of_worship",

        offeringCategory: "localExperience",
    },
    {
        type: "town_square",

        offeringCategory: "localExperience",
    },
];

export function placeTypesToOfferingCategories(
    types: string[] = [],
): OfferingCategory[] {
    return typeMappings
        .filter((t) => types.includes(t.type))
        .map((t) => t.offeringCategory)
        .filter((value, index, array) => array.indexOf(value) === index);
}
